<div style="height: Calc(100vh - 130px);">
  <as-split direction="horizontal" (dragEnd)="dragEnd('pixel', $event)">
    <as-split-area [size]="this.id === 'new' ? 100 : 68">
<div fxLayout="row" fxLayoutAlign="space-between center">
    <h2 class="row" style="margin-bottom: -5px;">{{ "tunnel-section.title" | translate }}</h2>
    <div *ngIf="topMenuIcons.length > 0">
      <button
          mat-raised-button
          [disabled]="
          !this.detailForm.valid ||
          this.disableByProfile"
          (click)="save()"
        >
        <mat-icon [title]="this.saveIconTitle"> save </mat-icon>
        </button>
        <!--button
          mat-raised-button
          *ngIf="this.id !== 'new'"
          [disabled]="this.disableByProfile"
          (click)="deleteConfirm()"
        >
        <mat-icon [title]="this.deleteIconTitle"> delete </mat-icon>
        </button---->
        <ng-container *ngFor="let action of topMenuIcons">
          <button
            mat-raised-button
            [routerLink]="action.routerLink"
            (click)="this[action.clickMethod]()"
            [disabled]="action.clickMethod === 'rasterExport' && rasterExportRunning"
            *ngIf="!action.hide"
          >
            <mat-icon [title]="action.clickMethod === 'rasterExport' && rasterExportRunning ? this.rasterExportRunningTitle : action.title"> {{ action.icon }} </mat-icon>
          </button>
        </ng-container>
    </div>
  </div>
  <form [formGroup]="detailForm">

    <div fxLayout="column">
      <div fxLayout="row wrap" fxLayoutGap="40px">
        <mat-form-field
          *ngIf="columnsVisible.get('id')"
          [ngStyle]="{
            'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label> {{ "tunnel-section.id" | translate }} </mat-label>
          <input
            matInput
            [ngStyle]="{
              'width.ch': detailForm.controls['id'].value ? detailForm.controls['id'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="id"
          />
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('name')"
          [ngStyle]="{
            'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
            'min-width.px': 300
          }"
        >
          <mat-label>{{ "tunnel-section.name" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['name'].value ? detailForm.controls['name'].value.length : 10,
              'min-width.px': 300
            }"
            formControlName="name"
          />
          <mat-error *ngIf="detailForm.controls['name'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
        </mat-form-field>

        <div style="margin-top: 15px;" [hidden]="this.id === 'new'">
          <button mat-raised-button (click)="this.recalculateSection()" [disabled]="this.id === 'new' || this.disableByProfile">
              {{ "tunnel-section.button-recalculate" | translate }}
          </button>
          <button
          mat-raised-button
          [disabled]="
          !this.detailForm.valid ||
          this.disableByProfile"
          (click)="showPopupQueue()"
        >
        <mat-icon [title]="this.queueTitle"> queue </mat-icon>
        </button>
      </div>

      <mat-form-field
       *ngIf="this.id !== 'new' && columnsVisible.get('created')"
       [ngStyle]="{
           'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
           'min-width.px': 200
        }"
        >
        <mat-label>{{ "tunnel-section.creation-date" | translate }}</mat-label>
        <input
        matInput
        [disabled]="true"
        class="form-control"
        [ngStyle]="{
            'width.ch': detailForm.controls['created'].value ? detailForm.controls['created'].value.length : 10,
            'min-width.px': 180
        }"
            value="{{ section.created | date:'yyyy-MM-dd HH:mm' }}"
            />
            <mat-error *ngIf="detailForm.controls['created'].errors?.['required']">
                {{ "error.required" | translate }}
            </mat-error>
        </mat-form-field>

      <mat-form-field
       *ngIf="this.id !== 'new' && columnsVisible.get('lastModificationDate')"
       [ngStyle]="{
           'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
           'min-width.px': 200
        }"
        >
        <mat-label>{{ "tunnel-section.modification-date" | translate }}</mat-label>
        <input
        matInput
        [disabled]="true"
        value="{{ section.lastModificationDate | date:'yyyy-MM-dd HH:mm' }}"
        class="form-control"
        [ngStyle]="{
            'width.ch': detailForm.controls['lastModificationDate'].value ? detailForm.controls['lastModificationDate'].value.length : 10,
            'min-width.px': 180
        }"
            />
            <mat-error *ngIf="detailForm.controls['lastModificationDate'].errors?.['required']">
                {{ "error.required" | translate }}
            </mat-error>
        </mat-form-field>


        <mat-checkbox *ngIf="columnsVisible.get('calculationInProgress')" [ngStyle]="{
          'width.ch': 10,
          'min-width.px': 120
        }" formControlName="calculationInProgress" >{{ "tunnel-section.calculationInProgress" | translate
        }}</mat-checkbox>
       </div>

       <div fxLayout="row wrap" fxLayoutGap="40px">
        <mat-form-field
        *ngIf="columnsVisible.get('startChainage')"
        [ngStyle]="{
          'width.ch': detailForm.controls['startChainage'].value ? detailForm.controls['startChainage'].value.length : 10,
          'min-width.px': 200
        }"
      >
        <mat-label>{{ "tunnel-section.start-chainage" | translate }}</mat-label>
        <input
          matInput
          type="number"
          class="form-control" [step]="countDecimalPlaces(detailForm.controls['startChainage'].value)"
          [ngStyle]="{
            'width.ch': detailForm.controls['startChainage'].value ? detailForm.controls['startChainage'].value.length : 10,
            'min-width.px': 180
          }"
          formControlName="startChainage"
        />
        <mat-error *ngIf="detailForm.controls['startChainage'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['startChainage'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field
       *ngIf="this.id !== 'new' && columnsVisible.get('calcStatus')"
       [ngStyle]="{
           'width.ch': detailForm.controls['calcStatus'].value ? detailForm.controls['calcStatus'].value.length : 10,
           'min-width.px': 200
        }"
        >
        <mat-label>{{ "tunnel-section.calc-status" | translate }}</mat-label>
        <input
        matInput
        formControlName="calcStatus"
        class="form-control"
        [ngStyle]="{
            'width.ch': detailForm.controls['calcStatus'].value ? detailForm.controls['calcStatus'].value.length : 10,
            'min-width.px': 180
        }"
            />
            <mat-error *ngIf="detailForm.controls['calcStatus'].errors?.['required']">
                {{ "error.required" | translate }}
            </mat-error>
        </mat-form-field>

      <mat-form-field
      *ngIf="this.id !== 'new' && columnsVisible.get('tunnelStatus')"
      [ngStyle]="{
          'width.ch': detailForm.controls['tunnelStatus'].value ? detailForm.controls['tunnelStatus'].value.length : 10,
          'min-width.px': 200
       }"
       >
       <mat-label>{{ "tunnel-section.tunnel-status" | translate }}</mat-label>
       <input
       matInput
       formControlName="tunnelStatus"
       class="form-control"
       [ngStyle]="{
           'width.ch': detailForm.controls['tunnelStatus'].value ? detailForm.controls['tunnelStatus'].value.length : 10,
           'min-width.px': 180
       }"
           />
           <mat-error *ngIf="detailForm.controls['tunnelStatus'].errors?.['required']">
               {{ "error.required" | translate }}
           </mat-error>
       </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('length')"
          [ngStyle]="{
            'width.ch': detailForm.controls['length'].value ? detailForm.controls['length'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.length" | translate }}</mat-label>
          <input
            matInput
            type="number | '.0-2'"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['length'].value)"
            [ngStyle]="{
              'width.ch': detailForm.controls['length'].value ? detailForm.controls['length'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="length"
          />
          <mat-error *ngIf="detailForm.controls['length'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['length'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('width')"
          [ngStyle]="{
            'width.ch': detailForm.controls['width'].value ? detailForm.controls['width'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.width" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['width'].value)"
            [ngStyle]="{
              'width.ch': detailForm.controls['width'].value ? detailForm.controls['width'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="width"
          />
          <mat-error *ngIf="detailForm.controls['width'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['width'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('beginSectionDepth')"
          [ngStyle]="{
            'width.ch': detailForm.controls['beginSectionDepth'].value ? detailForm.controls['beginSectionDepth'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.beginSectionDepth" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['beginSectionDepth'].value)"
            [ngStyle]="{
              'width.ch': detailForm.controls['beginSectionDepth'].value ? detailForm.controls['beginSectionDepth'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="beginSectionDepth"
          />
          <mat-error *ngIf="detailForm.controls['beginSectionDepth'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['beginSectionDepth'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('endSectionDepth')"
          [ngStyle]="{
            'width.ch': detailForm.controls['endSectionDepth'].value ? detailForm.controls['endSectionDepth'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.endSectionDepth" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['endSectionDepth'].value)"
            [ngStyle]="{
              'width.ch': detailForm.controls['endSectionDepth'].value ? detailForm.controls['endSectionDepth'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="endSectionDepth"
          />
          <mat-error *ngIf="detailForm.controls['endSectionDepth'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['endSectionDepth'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <div fxLayout="row wrap" fxLayoutGap="40px">
          <mat-form-field
            *ngIf="columnsVisible.get('designBeginSectionDepth')"
            [ngStyle]="{
              'width.ch': detailForm.controls['designBeginSectionDepth'].value ? detailForm.controls['designBeginSectionDepth'].value.length : 10,
              'min-width.px': 200
            }"
          >
            <mat-label>{{ "tunnel-section.design-begin-section-depth" | translate }}</mat-label>
            <input
              matInput
              type="number"
              class="form-control"
              [ngStyle]="{
                'width.ch': detailForm.controls['designBeginSectionDepth'].value ? detailForm.controls['designBeginSectionDepth'].value.length : 10,
                'min-width.px': 180
              }"
              formControlName="designBeginSectionDepth" [step]="countDecimalPlaces(detailForm.controls['designBeginSectionDepth'].value)"
            />
            <mat-error *ngIf="detailForm.controls['designBeginSectionDepth'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
            <mat-error *ngIf="detailForm.controls['designBeginSectionDepth'].errors?.['pattern']">{{ "error.number_pattern" |
              translate }}</mat-error>
          </mat-form-field>

          <mat-form-field
            *ngIf="columnsVisible.get('designEndSectionDepth')"
            [ngStyle]="{
              'width.ch': detailForm.controls['designEndSectionDepth'].value ? detailForm.controls['designEndSectionDepth'].value.length : 10,
              'min-width.px': 200
            }"
          >
            <mat-label>{{ "tunnel-section.design-end-section-depth" | translate }}</mat-label>
            <input
              matInput
              type="number"
              class="form-control"
              [ngStyle]="{
                'width.ch': detailForm.controls['designEndSectionDepth'].value ? detailForm.controls['designEndSectionDepth'].value.length : 10,
                'min-width.px': 180
              }"
              formControlName="designEndSectionDepth" [step]="countDecimalPlaces(detailForm.controls['designEndSectionDepth'].value)"
            />
            <mat-error *ngIf="detailForm.controls['designEndSectionDepth'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
            <mat-error *ngIf="detailForm.controls['designEndSectionDepth'].errors?.['pattern']">{{ "error.number_pattern" |
              translate }}</mat-error>
          </mat-form-field>
      </div>

      <div fxLayout="row wrap" fxLayoutGap="40px">
        <mat-form-field
          *ngIf="columnsVisible.get('gravelAvgAreaPerct')"
          [ngStyle]="{
            'width.ch': detailForm.controls['gravelAvgAreaPerct'].value ? detailForm.controls['gravelAvgAreaPerct'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label  class="word-wrap">{{ "tunnel-section.gravel-avg-area-perct" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['gravelAvgAreaPerct'].value)"
            [ngStyle]="{
              'margin-top': '0.9em',
              'width.ch': detailForm.controls['gravelAvgAreaPerct'].value ? detailForm.controls['gravelAvgAreaPerct'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="gravelAvgAreaPerct"
          />
          <mat-error *ngIf="detailForm.controls['gravelAvgAreaPerct'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['gravelAvgAreaPerct'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('gravelSpacing')"
          [ngStyle]="{
            'width.ch': detailForm.controls['gravelSpacing'].value ? detailForm.controls['gravelSpacing'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.gravel-spacing" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['gravelSpacing'].value)"
            [ngStyle]="{
              'width.ch': detailForm.controls['gravelSpacing'].value ? detailForm.controls['gravelSpacing'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="gravelSpacing"
          />
          <mat-error *ngIf="detailForm.controls['gravelSpacing'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['gravelSpacing'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('gravelStartPosition')"
          [ngStyle]="{
            'width.ch': detailForm.controls['gravelStartPosition'].value ? detailForm.controls['gravelStartPosition'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.gravel-start-position" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['gravelStartPosition'].value)"
            [ngStyle]="{
              'width.ch': detailForm.controls['gravelStartPosition'].value ? detailForm.controls['gravelStartPosition'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="gravelStartPosition"
          />
          <mat-error *ngIf="detailForm.controls['gravelStartPosition'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['gravelStartPosition'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field *ngIf="this.id !== 'new' && columnsVisible.get('gravelCalc_disabled')" [ngStyle]="{
          'width.ch': detailForm.controls['gravelCalc_disabled'].value ? detailForm.controls['gravelCalc_disabled'].value.length : 10,
          'min-width.px': 200
       }">
           <mat-label>{{ "tunnel-section.gravel-calc" | translate }}</mat-label>
           <input matInput [disabled]="true" [ngStyle]="{
           'width.ch': detailForm.controls['gravelCalc_disabled'].value ? detailForm.controls['gravelCalc_disabled'].value.length : 10,
           'min-width.px': 180
       }" formControlName="gravelCalc_disabled" />
         </mat-form-field>

        <app-gravel-calc-type-dropdown *ngIf="columnsVisible.get('gravelCalc')"
        (selectedChange)="this.setSelectedTypeGravelCalc($event)"
        [required]="true"
        [singleSelection]="true"
        [selected]="this.preSelectedTypeGravelCalc"
      ></app-gravel-calc-type-dropdown>

        <mat-form-field
          *ngIf="columnsVisible.get('kDistSoil')"
          [ngStyle]="{
            'width.ch': detailForm.controls['kDistSoil'].value ? detailForm.controls['kDistSoil'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.kDist-soil" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control" [step]="countDecimalPlaces(detailForm.controls['kDistSoil'].value)"
            [ngStyle]="{
              'width.ch': detailForm.controls['kDistSoil'].value ? detailForm.controls['kDistSoil'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="kDistSoil"
          />
          <mat-error *ngIf="detailForm.controls['kDistSoil'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['kDistSoil'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('kSubSoil')"
          [ngStyle]="{
            'width.ch': detailForm.controls['kSubSoil'].value ? detailForm.controls['kSubSoil'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.kSub-soil" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['kSubSoil'].value ? detailForm.controls['kSubSoil'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="kSubSoil" [step]="countDecimalPlaces(detailForm.controls['kSubSoil'].value)"
          />
          <mat-error *ngIf="detailForm.controls['kSubSoil'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['kSubSoil'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('minDepthSoil')"
          [ngStyle]="{
            'width.ch': detailForm.controls['minDepthSoil'].value ? detailForm.controls['minDepthSoil'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.min-depth-soil" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['minDepthSoil'].value ? detailForm.controls['minDepthSoil'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="minDepthSoil" [step]="countDecimalPlaces(detailForm.controls['minDepthSoil'].value)"
          />
          <mat-error *ngIf="detailForm.controls['minDepthSoil'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['minDepthSoil'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('maxDepthSoil')"
          [ngStyle]="{
            'width.ch': detailForm.controls['maxDepthSoil'].value ? detailForm.controls['maxDepthSoil'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.max-depth-soil" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['maxDepthSoil'].value ? detailForm.controls['maxDepthSoil'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="maxDepthSoil" [step]="countDecimalPlaces(detailForm.controls['maxDepthSoil'].value)"
          />
          <mat-error *ngIf="detailForm.controls['maxDepthSoil'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['maxDepthSoil'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('minGravelThickness')"
          [ngStyle]="{
            'width.ch': detailForm.controls['minGravelThickness'].value ? detailForm.controls['minGravelThickness'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.min-gravel-thickness" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['minGravelThickness'].value ? detailForm.controls['minGravelThickness'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="minGravelThickness" [step]="countDecimalPlaces(detailForm.controls['minGravelThickness'].value)"
          />
          <mat-error *ngIf="detailForm.controls['minGravelThickness'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['minGravelThickness'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('maxGravelThickness')"
          [ngStyle]="{
            'width.ch': detailForm.controls['maxGravelThickness'].value ? detailForm.controls['maxGravelThickness'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.max-gravel-thickness" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['maxGravelThickness'].value ? detailForm.controls['maxGravelThickness'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="maxGravelThickness" [step]="countDecimalPlaces(detailForm.controls['maxGravelThickness'].value)"
          />
          <mat-error *ngIf="detailForm.controls['maxGravelThickness'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['maxGravelThickness'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
          *ngIf="columnsVisible.get('stressPatternAvg')"
          [ngStyle]="{
            'width.ch': detailForm.controls['stressPatternAvg'].value ? detailForm.controls['stressPatternAvg'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.stress-pattern-avg" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['stressPatternAvg'].value ? detailForm.controls['stressPatternAvg'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="stressPatternAvg" [step]="countDecimalPlaces(detailForm.controls['stressPatternAvg'].value)"
          />
          <mat-error *ngIf="detailForm.controls['stressPatternAvg'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['stressPatternAvg'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>

        <mat-form-field
        *ngIf="columnsVisible.get('gravelTopDiffTunnelBottomAvg')"
        [ngStyle]="{
          'width.ch': detailForm.controls['gravelTopDiffTunnelBottomAvg'].value ? detailForm.controls['gravelTopDiffTunnelBottomAvg'].value.length : 10,
          'min-width.px': 200
        }"
      >
        <mat-label class="word-wrap">{{ "tunnel-section.gravel-top-diff-tunnel-bottom-avg" | translate }}</mat-label>
        <input
          matInput
          type="number"
          class="form-control"
          [ngStyle]="{
            'margin-top': '0.9em',
            'width.ch': detailForm.controls['gravelTopDiffTunnelBottomAvg'].value ? detailForm.controls['gravelTopDiffTunnelBottomAvg'].value.length : 10,
            'min-width.px': 180
          }"
          formControlName="gravelTopDiffTunnelBottomAvg" [step]="countDecimalPlaces(detailForm.controls['gravelTopDiffTunnelBottomAvg'].value)"
        />
        <mat-error *ngIf="detailForm.controls['gravelTopDiffTunnelBottomAvg'].errors?.['required']">
          {{ "error.required" | translate }}
        </mat-error>
        <mat-error *ngIf="detailForm.controls['gravelTopDiffTunnelBottomAvg'].errors?.['pattern']">{{ "error.number_pattern" |
          translate }}</mat-error>
      </mat-form-field>

      <mat-form-field
      *ngIf="columnsVisible.get('tunnelDisplacementAvg')"
      [ngStyle]="{
        'width.ch': detailForm.controls['tunnelDisplacementAvg'].value ? detailForm.controls['tunnelDisplacementAvg'].value.length : 10,
        'min-width.px': 200
      }"
    >
      <mat-label>{{ "tunnel-section.tunnel-displacement-avg" | translate }}</mat-label>
      <input
        matInput
        type="number"
        class="form-control"
        [ngStyle]="{
          'width.ch': detailForm.controls['tunnelDisplacementAvg'].value ? detailForm.controls['tunnelDisplacementAvg'].value.length : 10,
          'min-width.px': 180
        }"
        formControlName="tunnelDisplacementAvg" [step]="countDecimalPlaces(detailForm.controls['tunnelDisplacementAvg'].value)"
      />
      <mat-error *ngIf="detailForm.controls['tunnelDisplacementAvg'].errors?.['required']">
        {{ "error.required" | translate }}
      </mat-error>
      <mat-error *ngIf="detailForm.controls['gravelTopDiffTunnelBottomAvg'].errors?.['pattern']">{{ "error.number_pattern" |
        translate }}</mat-error>
    </mat-form-field>

    <mat-form-field
      *ngIf="columnsVisible.get('maxPrecSpecs')"
      [ngStyle]="{
        'width.ch': detailForm.controls['maxPrecSpecs'].value ? detailForm.controls['maxPrecSpecs'].value.length : 10,
        'min-width.px': 200
      }"
    >
      <mat-label>{{ "tunnel-section.max-prec-specs" | translate }}</mat-label>
      <input
        matInput
        type="number"
        class="form-control"
        [ngStyle]="{
          'width.ch': detailForm.controls['maxPrecSpecs'].value ? detailForm.controls['maxPrecSpecs'].value.length : 10,
          'min-width.px': 180
        }"
        formControlName="maxPrecSpecs" [step]="countDecimalPlaces(detailForm.controls['maxPrecSpecs'].value)"
      />
      <mat-error *ngIf="detailForm.controls['maxPrecSpecs'].errors?.['required']">
        {{ "error.required" | translate }}
      </mat-error>
      <mat-error *ngIf="detailForm.controls['maxPrecSpecs'].errors?.['pattern']">{{ "error.number_pattern" |
        translate }}</mat-error>
    </mat-form-field>

    <div fxLayout="column" fxLayoutGap="16px">

      <!-- Label on its own row -->
      <mat-label class="mat-form-field-label-header">
        {{ "tunnel-section.d" | translate }}
      </mat-label>
    <!-- Inputs in a row -->
    <div fxLayout="row wrap" fxLayoutGap="40px">
      <mat-form-field
            *ngIf="columnsVisible.get('d1')"
            [ngStyle]="{
              'width.ch': detailForm.controls['d1'].value ? detailForm.controls['d1'].value.length : 10,
              'min-width.px': 200
            }"
          >
            <mat-label>{{ "tunnel-section.d1" | translate }}</mat-label>
            <input
              matInput
              type="number"
              class="form-control"
              [ngStyle]="{
                'width.ch': detailForm.controls['d1'].value ? detailForm.controls['d1'].value.length : 10,
                'min-width.px': 180
              }"
              formControlName="d1" [step]="countDecimalPlaces(detailForm.controls['d1'].value)"
            />
            <mat-error *ngIf="detailForm.controls['d1'].errors?.['required']">
              {{ "error.required" | translate }}
            </mat-error>
            <mat-error *ngIf="detailForm.controls['d1'].errors?.['pattern']">{{ "error.number_pattern" |
              translate }}</mat-error>
          </mat-form-field>
          <mat-form-field
          *ngIf="columnsVisible.get('minGravelThickness')"
          [ngStyle]="{
            'width.ch': detailForm.controls['minGravelThickness'].value ? detailForm.controls['minGravelThickness'].value.length : 10,
            'min-width.px': 200
          }"
        >
          <mat-label>{{ "tunnel-section.d2" | translate }}</mat-label>
          <input
            matInput
            type="number"
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['d2'].value ? detailForm.controls['d2'].value.length : 10,
              'min-width.px': 180
            }"
            formControlName="d2" [step]="countDecimalPlaces(detailForm.controls['d2'].value)"
          />
          <mat-error *ngIf="detailForm.controls['d2'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['d2'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>
    </div>
    </div>
      </div>

        <mat-form-field
          *ngIf="columnsVisible.get('latestError')"
          [ngStyle]="{
            'width.ch': detailForm.controls['latestError'].value ? detailForm.controls['latestError'].value.length : 10,
            'min-width.px': 500
          }"
        >
          <mat-label>{{ "tunnel-section.latest-error" | translate }}</mat-label>
          <input
            matInput
            class="form-control"
            [ngStyle]="{
              'width.ch': detailForm.controls['latestError'].value ? detailForm.controls['latestError'].value.length : 10,
              'min-width.px': 500
            }"
            formControlName="latestError" [step]="countDecimalPlaces(detailForm.controls['latestError'].value)"
          />
          <mat-error *ngIf="detailForm.controls['latestError'].errors?.['required']">
            {{ "error.required" | translate }}
          </mat-error>
          <mat-error *ngIf="detailForm.controls['latestError'].errors?.['pattern']">{{ "error.number_pattern" |
            translate }}</mat-error>
        </mat-form-field>
       </div>

       </div>

    <mat-accordion multi>

      <mat-expansion-panel [expanded]="step === 1" (opened)="setStep(1)" >
        <mat-expansion-panel-header>
          <mat-panel-title>
            {{ "tunnel-section.header-berm-positions" | translate }}
          </mat-panel-title>
          </mat-expansion-panel-header>
          <mat-panel-description>
            <div fxLayout="column">
              <div  fxLayout="row wrap" fxLayoutGap="40px">
                <button (click)="initBermPositions()" style="margin-left:2px; max-width: 100px;">Remove all</button>
                <button (click)="pasteBermPositions()" style="margin-left:2px; max-width: 130px;">Paste from clipboard</button>
                <div>{{this.section?.bermPositions?.length}} positions</div>
              </div>
           <div  fxLayout="row wrap" fxLayoutGap="40px">
            <div fxLayout="column" *ngIf="columnsVisible.get('bermPosition') && section.bermPositions">
              <div *ngIf="this.itemsBermPosition.length > 0">
                <ng-container  *ngFor="let row of this.itemsBermPosition; index as i">
                    <app-list-input class="row" [items]="this.itemsBermPosition" [currentIndex]="i" [value]="this.itemsBermPosition[i]" [step]="countDecimalPlaces(this.itemsBermPosition[i])"
                    (rowChange)="this.changeBermPosition($event)" [editable]="true" [itemsPrefix]="itemsPrefix" ></app-list-input>
                  </ng-container>
              </div>

                <div *ngIf="this.itemsBermPosition.length === 0">
                  <app-list-input class="row" [items]="this.itemsBermPosition" [currentIndex]="0"
                      (rowChange)="this.changeBermPosition($event)" [editable]="true" [itemsPrefix]="itemsPrefix"></app-list-input>
                </div>

            </div>
            </div>

            </div>
      </mat-panel-description>
    </mat-expansion-panel>

    <mat-expansion-panel [expanded]="step === 2" (opened)="setStep(2)" >
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ "tunnel-section.header-positions" | translate }}
        </mat-panel-title>
        </mat-expansion-panel-header>
        <mat-panel-description>
     <div  fxLayout="row wrap" fxLayoutGap="40px">
      <div fxLayout="column" *ngIf="columnsVisible.get('longitudinalPosition') && section.longitudinalPosition">
        <mat-label>{{ "tunnel-section.longitudinalPosition" | translate }}</mat-label>
        <ng-container *ngFor="let row of this.itemsLongitudinalPosition; index as i">
          <app-list-input class="row" [items]="this.itemsLongitudinalPosition" [currentIndex]="i" [value]="this.itemsLongitudinalPosition[i]" [step]="countDecimalPlaces(this.itemsLongitudinalPosition[i])"
          (rowChange)="this.changeLongitudinalPosition($event)" [disabled]="true"></app-list-input>
        </ng-container>

      </div>


      <div fxLayout="column" *ngIf="columnsVisible.get('transversalPosition') && section.transversalPosition">
        <mat-label>{{ "tunnel-section.transversalPosition" | translate }}</mat-label>

        <ng-container *ngFor="let row of this.itemsTransversalPosition; index as i">
          <app-list-input class="row" [items]="this.itemsTransversalPosition" [currentIndex]="i" [value]="this.itemsTransversalPosition[i]"   [step]="countDecimalPlaces(this.itemsTransversalPosition[i])"
          (rowChange)="this.changeTransversalPosition($event)" [disabled]="true"></app-list-input>
        </ng-container>
        </div>
      </div>
    </mat-panel-description>
  </mat-expansion-panel>

    <mat-expansion-panel [expanded]="step === 3" (opened)="setStep(3)">
      <mat-expansion-panel-header>
        <mat-panel-title>
          {{ 'log-messages.title' | translate }}
        </mat-panel-title>
      </mat-expansion-panel-header>
        <mat-panel-description>
      <app-log-messages-list [ngStyle]="{
        'width.pc': 100
      }" [modelId]="this.id"></app-log-messages-list>
      </mat-panel-description>
    </mat-expansion-panel>
  </mat-accordion>

    </form>
  </as-split-area>
  <as-split-area [size]="this.id === 'new' ? 0 : 32">
    <app-map *ngIf="this.id !== 'new'" target="section-map"  [rastersOnMap]="true" [stressAreasOnMap]="true" [dataPopup]="true" [lsService]="lsService"></app-map>
  </as-split-area>
</as-split>
</div>